import axios from "vue-app/utils/axios";
import { DTOWorkingHours } from "vue-app/api/dto";

export const getWorkingHours = async () => {
  const { data } = await axios.get<{ days: DTOWorkingHours[] }>("/account/working-hours");
  return data;
};

export const editWorkingHours = async (params: DTOWorkingHours[]) => {
  const { data } = await axios.put<{ days: DTOWorkingHours }>("/account/working-hours", { days: params });
  return data;
};
